export default class BeneficiaryRequiredField {

    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.beneficiaryId = jsonResponse["beneficiary-id"];
        this.requiredFieldId = jsonResponse["required-field-id"];
        this.value = jsonResponse["value"];
        this.displayName = jsonResponse["display-name"];
        this.dataType = jsonResponse["data-type"];

    }
}
